import React, { useState, useEffect, useRef} from 'react';
import { useParams , useNavigate} from 'react-router-dom';
import axios from 'axios';
//import { GanttComponent , DayMarkers, HolidaysDirective, Inject, HolidayDirective } from '@syncfusion/ej2-react-gantt';
import "../assets/css/styles.table.css"
import { DataGrid  } from '@mui/x-data-grid';
import '../App.css';
import AxiosFetchData from '../pages/AxiosFetchData.js'
import { setValue } from '@syncfusion/ej2-base';
import Box from '@mui/material/Box';
import { Typography, Modal, 
} from '@mui/material';
import { DialogFormTemplate } from '../pages/template';
import { ColumnDirective, ColumnsDirective, TreeGridComponent,RowDD,Inject , Aggregate, AggregatesDirective } from '@syncfusion/ej2-react-treegrid';
import { Edit, Toolbar, AggregateColumnDirective, AggregateColumnsDirective, AggregateDirective, extendArray   } from '@syncfusion/ej2-react-treegrid';
import { getValue } from '@syncfusion/ej2-base';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import VirtualizedSelect from 'react-virtualized-select';
import Button from '@mui/material/Button';
import { dataSourceChanged, getObject, row } from '@syncfusion/ej2-grids';
 
import Helper from '../pages/Helper.js'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import RemoveIcon from '@mui/icons-material/Remove';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import ConfirmationButton from '../components/ConfirmationButton'  ;
import PrintPreview from '../components/PrintReviewV3.js';
import { apiUrl } from '../pages/UrlParam.js'
import DatePicker from 'react-datepicker'; 
import MainPrint from '../pages/MainPrint.js';

export const useEditInvoicesHook = (id,id2,treegrid) =>{
    const Navigate = useNavigate()
    const [rows, setRows] = useState([]);
    const [confirmTaskOpen,setConfirmTaskOpen] = useState(false);
    const [open, setOpen] =  useState(false);
    const [taskName, setTaskName] = useState({});
    const [action, setAction] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [typeList, setTypeList] = useState([]);
    const [idTask, setIdTask] = useState('');
    const [confirmDeleteOpen,setConfirmDeleteOpen] = useState(false);
    const [partNo, setPartNo] = useState('');
    const [qty ,setQty] = useState(0);
    const [description ,setDescription] = useState('');
    const [price ,setPrice] = useState(0);
    const [total ,setTotal] = useState(0);
    const [totalOrigin ,setTotalOrigin] = useState(0);
    const [grandTotal ,setGrandTotal] = useState(0);
    const [isLastId ,setIsLastId] = useState(true);
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('ReturnUrl');
    const [persentase ,setPersentase] = useState(0);
    const [projectId, setProjectId] = useState('');
    const [message ,setmessage] = useState('');
    const [tipe ,settipe] = useState('');
    const [retensi ,setRetensi] = useState(0);
    const [retensiVal ,setRetensiVal] = useState(0);
    const [totalAfterRetention ,setTotalAfterRetention] = useState(0);
    const [InvoiceType ,setInvoiceType] = useState('Percent');
    const [persentaseNominal ,setPersentaseNominal] = useState(0);
    const [rev, setRev] =  useState(0);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [revTemp, setRevtemp] =  useState(0);
    const [revRows, setRevRows] =  useState([]);
    const [invoiceCode ,setInvoiceCode] = useState('');
    const menuOpen = Boolean(anchorEl);
    const [treedata ,setTreedata] = useState('');
    const [tax, setTax] =  useState(0);
    const [customer ,setCustomer] = useState('');
    const [roleAccess, setRoleAccess] = useState([]);
    const [initialretensi, setinitialretensi] = useState([]);
    const [paymentTermList, setPaymentTermList] = useState([]);
    const [selectedDate, setSelectedDate] =  useState(new Date());
    const [selectedDueDate, setSelectedDueDate] =  useState(new Date());
    const [selectedOptionPaymentTerm ,setSelectedOptionPaymentTerm] = useState('');
    const [pph ,setPph] = useState(0);
    const [pphValue ,setPphValue] = useState(0);

    const handleClick = (event,data) => {
           setAnchorEl(event.currentTarget);
        };
        const handleMenuClose = () => {
          setAnchorEl(null);
        };
    
    
        useEffect(  () => {
              GetTaskList();
              
         }, [Navigate]);
    
    
        const GetRetention = async (persentase, persentaseNominal=null) => {
          try{
            var response =  await AxiosFetchData.get(`GetInvoiceV3/${id}/${id2}`).refreshToken(Navigate,"invoice");
            if(response){
                 
                setinitialretensi(response.data.resp.retention)
                if(persentase == 100  || (persentaseNominal && (persentaseNominal == 100))){
                    setRetensi(response.data.resp.retention)
                }else{
                    setRetensi(0)
                }
                
            }
             
          }catch(err){
            setmessage(err.message)
            settipe('errorlog')
          }
          
          
        }
    
        function GetPayTerm(payment){
            axios.get(`${apiUrl}/api/GetPayTerm`)
            .then((response) => {
              const transformedOptions = response.data.map((item) => ({
                label: `${item.name} - ${item.day} day`,
                value: item.id,
              }));
    
              setPaymentTermList(transformedOptions);
               
              if(!selectedOptionPaymentTerm){
              
                setSelectedOptionPaymentTerm({label : `${payment.paymenttermname} - ${payment.paymenttermday} day`, value : payment.paymenttermid})
              }
             
            })
            .catch((error) => {
              console.error('Error fetching category data:', error);
            });
             
        }
    
        const GetTaskList = async () => {
           try{
             
            const response = await AxiosFetchData.get(`GetInvoiceV3/${id}/${id2}`).refreshToken(Navigate,"invoice")
          
            if(response){   
                const rowsWithRowNumbers = response.data.data.map((row, index) => ({
                    rowNumber: index + 1,
                    invoice_id: row.invoice_id,
                    part_no: row.part_no,
                    descriptions: row.descriptions,
                    newqty: row.newqty,
                    price: row.price,
                    expanded : row.expanded,
                    type:row.type,
                    code :row.code,
                    unit_name:row.unit_name,
                    product_type : row.product_type,
                    subChild:row.subChild,
                  }));
    
                  var data = {
                    paymenttermid :response.data.resp.paymenttermid,
                    paymenttermname : response.data.resp.paymenttermname,
                    paymenttermday : response.data.resp.paymenttermday,
                  }
    
                  GetPayTerm(data);
                  setSelectedDate(new Date(response.data.resp.tanggal))
                  setSelectedDueDate(new Date(response.data.resp.retention_due_date))
                  setRoleAccess(response.roleaccess)
                  setRows(rowsWithRowNumbers);
                  setTax(response.data.quotation.tax)
                  setPph(response.data.quotation.pph)
                  setPphValue(response.data.resp.pph_value)
                  setTotal(response.data.resp.total);
                  setInvoiceCode(response.data.resp.kode);
                  
                  var totalpo = await AxiosFetchData.get(`IsExistSplitInvoice/${response.data.resp.project_id}`).refreshToken(Navigate,"invoice")
                  setTotalOrigin(totalpo.data.length == 0 ? 0 : totalpo.data.find((val) => val.id == id2).total)
     
                  setProjectId(response.data.resp.project_id)
                  setCustomer(response.data.resp.kode.split('/')[2])
                
                  setPersentase(response.data.resp.type == "Percent" ? response.data.resp.persentase : response.data.resp.total);
                  
                  if(response.data.resp.type == "Nominal"){
                    setPersentaseNominal(response.data.resp.persentase)
                  }
    
                  setRevtemp(response.data.resp.rev)
                  setRev(response.data.resp.rev)
                  setDescription(response.data.resp.deskripsi);
                  setInvoiceType(response.data.resp.type)
                  if(response.data.customer[0].lastId == id){
                        setIsLastId(false);
                  }
    
                  await GetRetention(response.data.resp.persentase)
                  await GetRev();
            }
           }catch(e){
              setmessage(e.message);
              settipe('errorlog')
           }
        }
    
        const AddTask = async (e) => {
            e.preventDefault(); 
           if(action === 'AddParent'){
            var data = {
              invoice_id : Math.random().toString().split('.')[1],
              part_no :partNo,
              descriptions : description,
              newqty:qty,
              price : price
            }
           }
        
           setConfirmTaskOpen(false)
        }
        
        async function handleDeleteConfirmation(){
          try{
            const response = await AxiosFetchData.delete(`DeleteTask/${idTask}`).refreshToken(Navigate,"invoice");
            if(response){
                setConfirmDeleteOpen(false);
                setmessage(response.data)
                await GetTaskList()
            }
          }catch(err){
            setmessage(err.message)
            settipe('errorlog')
          }
           
        }
    
        const AddParentTask = async () => {
             try{
              
              var response;
              if(grandTotal !== total)  
              {
                setmessage("total should be the same as invoice")
                settipe('error')
                return;
              }
    
              var data ={
                data : JSON.stringify(treegrid.getCurrentViewRecords()),
                id:id,
                deskripsi: description, 
                persentase: InvoiceType == "Percent" ? persentase : persentaseNominal,
                total : totalAfterRetention,
                total_all : totalOrigin,
                retensiVal : retensiVal,
                type : InvoiceType,
                rev : rev,
                kode : invoiceCode,
                retention : initialretensi,
                split_invoice_id : id2,
                tanggal : selectedDate,
                retention_due_date : selectedDueDate,
                payment_term : selectedOptionPaymentTerm.value,
                pph : pph,
                pph_value :pphValue
              }
      
             // console.log(data);
             // return;
              if(revTemp == rev){
                response = await AxiosFetchData.post("EditInvoiceV3",data).refreshToken(Navigate,"invoice");
              }
    
              if(revTemp != rev){
                delete data.id;
              
                data.status = "Unpaid";
                data.project_id = projectId;
                data.rev = rev;
                data.rev_default= 0;
                data.kode = invoiceCode;
    
                response = await AxiosFetchData.post("AddInvoiceV3",data).refreshToken(Navigate,"invoice");
              }
             
              if(response){
                if(response.data.includes('invoice')){
                  setmessage(response.data)
                  settipe('errorlog')
                  return;
                }
                 
                Navigate(`/${myParam}`)
              }
             }catch(err){
                setmessage(err.message)
                settipe('errorlog')
             }
            
        };
       
     
      //  let treegrid;
        const toolbarOptions = ['Add', 'Edit', 'Delete',  { text: 'Clear', tooltipText: 'Clear', id: 'toolbarfilter', align: 'Right' },{ text: 'Default', tooltipText: 'Default', id: 'toolbarfilter2', align: 'Right' },{ text: 'Preview', tooltipText: 'Preview', id: 'toolbarfilter3', align: 'Right' }];
        const dialogTemplate = (props) => {
            const obj = [props, treegrid];
            return (<DialogFormTemplate {...obj}/>);
        };
    
        const editOptions = {
            allowAdding: true,
            allowDeleting: true,
            allowEditing: true,
            mode: 'Dialog',
            newRowPosition: 'Child',
            template: dialogTemplate
        };
    
        const actionComplete = (args) => {
            if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                const form = args.form;
                if (args.requestType === 'beginEdit') {
                  console.log(args.form.elements.namedItem("part_no"))
                }
            }
    
            if (args.requestType === 'save') {
              
            }
        };
    
        const actionBegin = (args) => {
            if (args.requestType === 'save') {
              
            }
    
            if ((args.requestType === 'add')) {
                setValue('data.invoice_id',Math.random().toString().split('.')[1], args);
                setValue('data.type',"new", args);
            }
    
            if ((args.requestType === 'delete')) {
             
            }
        };
    
        function  rowDrop(args) {
          
          if (args.dropPosition == 'middleSegment' || Object.keys( args.dropPosition).length == 0) {
             args.cancel = true;
             treegrid.reorderRows([args.fromIndex], args.dropIndex, 'above');
          }
        }
      
        const TotalTemplate = (props) => {
           if (getObject('price', props) != null && getObject('newqty', props) != null) {
                return Helper.formatAsCurrency((getObject('price', props) * getObject('newqty', props)));
             }
             return null;
        };
    
        const priceTemplate = (field, data, column) => {
          if (getValue('price', data) != null) {
            return  Helper.formatAsCurrency(getValue('price', data));
          }
          return null;
        };
     
        const customAggregateFn = (row) => {
            const sampleData = getObject('result', row);
        
            let data = 0;
            if(sampleData){
                sampleData.filter((item) => {
                    if(getObject('price', item) && getObject('newqty', item)){
                        data += getObject('price', item) * getObject('newqty', item);
                    }
                      
                    
                });
            }
          
            setGrandTotal(data)
            return data;
        };
    
      const custom1 = (props) => {
          return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>Total :</td><td>{(Helper.formatAsCurrency(getObject('Custom', props)))}</td></tr></table>)
      };
    
      const custom =   (props) => {
        return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>inv{InvoiceType=="Percent" ? "(" + persentase + '%)' : ''} :</td><td>{Helper.formatAsCurrency(total)}</td></tr></table>)
      };
    
      const custom2 =  (props) => {
          setRetensiVal(totalOrigin * (retensi / 100));
          return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>Retention({retensi}%) :</td><td>{Helper.formatAsCurrency(totalOrigin * (retensi / 100))}</td></tr></table>)
       };
    
       
       const custom3 = (props) => {
          setTotalAfterRetention(total - (totalOrigin * (retensi / 100)));
          return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>Grand Total:</td><td>{Helper.formatAsCurrency(total - (totalOrigin * (retensi / 100)))}</td></tr></table>)
       };
        
    
        async function handleTotal(data)
        {
          if(!data){
            data = 0;
           }
         
           var index = 0;
           if(data.toString().length > (((data * 1).toString())).length){
             index = data.toString().length - (((data * 1).toString())).length
           }
         
          data = data.toString().substring(index)
    
          if(parseFloat(data) > 100 && InvoiceType == 'Percent'){
            setmessage("must be smaller than 100%")
            settipe('error')
            return;
          }
        
          setPersentase(data)
        
          try
          {
            const response = await AxiosFetchData.get(`GetINVV3/${projectId}/${data}/${totalOrigin}/${InvoiceType}/${id2}/${id}`).refreshToken(Navigate,"invoice");
            if(response){
              setTotal(response.data.value);
              if(InvoiceType == "Nominal"){
                setPersentaseNominal(response.data.persentase);
                if(response.data.persentase > 100 && InvoiceType == 'Nominal'){
                  setmessage("must be smaller than 100%")
                  settipe('error')
                  setPersentase(0)
                  setTotal(0)
                  return;
                }
              }
    
                if(data == 100  || (response.data.persentase && (response.data.persentase == 100))){
                    setRetensi(initialretensi)
                }else{
                    setRetensi(0)
                }
             }
          }catch(e){
            setmessage(e.message)
            settipe('errorlog')
          }
        }
    
        const toolbarClick = (args) => {
          
          if ( args.item.text ==='Clear') {
              setRows([])
          }
        
          if ( args.item.text ==='Default') {
              GetTaskList();
          }
    
          if (args.item.text ==='Preview') {
              document.getElementById('btnPreview').click();
             
          }
          
        };
    
        function handlePreview(){
          var data = {
            treeview : treegrid.getCurrentViewRecords(),
            invoice : {
              persentase : persentase,
              total_all :  totalOrigin,
              total : total,
              kode : invoiceCode,
              tax : tax,
              pph : pph,
              pph_value : pphValue,
              date : selectedDate,
              due_date : selectedDueDate,
              payment_term : selectedOptionPaymentTerm.label,
            },
            retensi : retensi,
            note : description
        }
       
        setTreedata(JSON.stringify(data))
        setOpen(true);
        }
    
        const handleRev = async (type) => {
          const response = await AxiosFetchData.get(`GetLastRev/${projectId}/${id}/${encodeURIComponent(invoiceCode)}`).refreshToken(Navigate,"invoice");
          
          if(response){
              if(type=='add'){
                  setRev(parseInt(response.data) + 1)
              }else{
                  setRev(revTemp)
              }
              
              setAnchorEl(null);
          }
          
      }
    
      async function handleDefault(){
        try{
            const response = await AxiosFetchData.get(`SetDefaultInvoiceV3/${id}/${id2}`).refreshToken(Navigate,"invoice");
            if(response){
                
                setmessage(response.data);
                await GetRev();
                setAnchorEl(null)
            }
        }catch(err){
            setmessage(err.message);
            settipe('errorlog')
        }
        
      }
    
      async function GetRev(){
        try{
            var response = await AxiosFetchData.get(`GetInvoiceRev/${id}`).refreshToken(Navigate,"invoice");
           
            if(response.data){
                const rowsWithRowNumbers = response.data.map((row, index) => ({
                    ...row,
                    rowNumber: index + 1,
                   
                }));
    
                setRevRows(rowsWithRowNumbers)
               
            }
        }catch(e){
            setmessage(e.message)
            settipe('errorlog')
        }
       
      }
    
      function handleSelectedPaymentTerm(option){
        var addDay = new MainPrint();
        setSelectedDueDate(addDay.addDays(selectedDate, parseInt(option.label.split(' - ')[1].split(' ')[0].trim())))
        setSelectedOptionPaymentTerm(option)
    }
    
      const revColumns= [
        { field: 'rowNumber', headerName: 'No.', width: 50 },
        // { field: 'id', headerName: 'ID.', width: 250, hideable: false},
        //   { field: 'default_rev', headerName: 'Default.', width: 100 },
        {
            field: 'action',
            headerName: '',
            width: 150,
           
            renderCell: (params) => (
              <>
               <Button    
                   onClick={() => Navigate(`/EditInvoiceV3/${params.row.id}/${id2}?ReturnUrl=${myParam}`)} // Pass the project ID to the edit function
                //  className="btn btn-primary mr-2"
                 >
                 <ModeEditIcon  sx={{ fontSize: 15 }}/>
                </Button>
               &nbsp; 
               <ConfirmationButton disabled={roleAccess.DELETE == true ? (isLastId) : !roleAccess.DELETE} classname='btn btn-danger' text="Do you want delete this data?" type="button" title="Delete"  onClick={() => handleDeleteRev(params.row.id,params.row.rev_default)} >
                          <DeleteForeverIcon sx={{fontSize:15}} />
               </ConfirmationButton>
               
              </>
              
            ),
        },
        {
            field: 'isDefault',
            headerName: 'Default',
            width: 100,
            renderCell: (params) => (
              <>
              {params.row.rev_default == 1 && (
                  
                  <CheckCircleIcon  sx={{ fontSize: 20 }}/>
                
              )}
              </>
            ),
        },
        { field: 'rev', headerName: 'Rev#', width: 50 },
        { field: 'tanggal', headerName: 'Date', width: 100 },
        { field: 'createdAt', headerName: 'Created Date', width: 200 },
        { field: 'total', headerName: 'Total', width: 150, valueGetter:({ value }) => value && Helper.formatAsCurrency(value) },
        { field: 'total_all', headerName: 'Grand Total', width: 150, valueGetter:({ value }) => value && Helper.formatAsCurrency(value) },
        { field: 'persentase', headerName: 'INV', width: 50 },
        { field: 'deskripsi', headerName: 'Descriptions', width: 200 },
         
      ];
    
      async function handleDeleteRev(id, revDefault){
        try{
            const response = await AxiosFetchData.delete(`DeleteRevV3/${id}/${id2}/${revDefault}`).refreshToken(Navigate,"invoice")
            if(response){
                setmessage(response.data.msg)
                if(response.data.value == 0){
                    await GetRev();
                    return;
                }
    
                setTimeout(() => {
                    Navigate(`/EditInvoiceV3/${response.data.value}/${id2}?ReturnUrl=${myParam}`)
                }, 300);
                
            }
        }catch(err){
            setmessage(err.message)
            settipe('errorlog')
        }
            
      }
      const settings = { wrapMode: 'Content' };

      return {message,setmessage,tipe,settipe,invoiceCode,rev,open,handleClick,isLastId,anchorEl,menuOpen,handleMenuClose,handleRev,handleDefault,
                revRows,revColumns,roleAccess,AddParentTask,handlePreview,persentase,handleTotal,setInvoiceType,setPersentase,setTotal,InvoiceType,pph,setPph,pphValue,
                invoiceCode,customer,setCustomer,paymentTermList,handleSelectedPaymentTerm,selectedOptionPaymentTerm,selectedDate,setSelectedDate,selectedDueDate,setSelectedDueDate,
                description,setDescription,rows,editOptions,toolbarOptions,actionBegin,actionComplete,rowDrop,toolbarClick,settings,priceTemplate,TotalTemplate,customAggregateFn,custom,
                custom2,custom3,confirmTaskOpen,AddTask,typeList,setSelectedType,selectedType,partNo,setPartNo,qty,setQty,price,setPrice,confirmDeleteOpen,setConfirmDeleteOpen,taskName,
                handleDeleteConfirmation,setConfirmDeleteOpen,treedata,setPphValue,custom1,setOpen,setConfirmTaskOpen
      }
}